module.exports = __webpack_public_path__ + "static/media/check_mark_green.0a070626.svg";